import { styled, useTheme } from '@mui/material'
import { Avatar, AvatarProps } from '@carto/meridian-ds/components'
import { getCartoColorStylePropsForItem } from '@carto/meridian-ds/theme'
import { getColorIndex } from 'features/common/utils/colors'
import { AvatarData } from 'features/users/types'
import { useUserHasGravatar } from 'features/users/hooks/useUserHasGravatar'

export type GravatarProps = AvatarData &
  AvatarProps & {
    alt?: string
    email?: string
    'aria-label'?: string
    AvatarComponent?: React.ComponentType<AvatarProps>
  }

const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isClickable'
})<{
  isClickable?: boolean
}>(({ isClickable }) => ({
  textTransform: 'uppercase',

  ...(isClickable && {
    cursor: 'pointer'
  })
}))

function Gravatar({
  userImage,
  onClick,
  acronym,
  alt,
  email,
  size = 'medium',
  'aria-label': ariaLabel,
  AvatarComponent = Avatar,
  ...avatarProps
}: GravatarProps) {
  const theme = useTheme()

  const { hasGravatar, userImageIsFromGravatar } = useUserHasGravatar({ email, userImage })

  const srcUrl = userImageIsFromGravatar ? (hasGravatar ? userImage : undefined) : userImage

  return (
    <Root
      isClickable={!!onClick}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
      aria-label={ariaLabel ?? 'user avatar'}
    >
      <AvatarComponent
        src={srcUrl}
        size={size}
        style={getCartoColorStylePropsForItem(theme, getColorIndex(alt || acronym))}
        {...avatarProps}
      >
        {!srcUrl && acronym}
      </AvatarComponent>
    </Root>
  )
}

export default Gravatar
